// このファイルは自動生成されています
/**
 *  [2024] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */
/**
 * Lambdaへのアクセスのためのドライバーをラップするコード
 * 複数のレコードをまとめて登録する
 */

import {Logger} from '@zettant/logger';
import {IErrorMessage} from '@zettant/logger/errorMessages';
import {awsLogout} from '@zettant/awsUtils';
import {IResponse} from '../interfaces';
import * as multiOrganizationCaseDataManagementDrv from '../multiOrganizationCaseDataManagementDrv';
// ----ADDITIONAL_IMPORTS----
// ----END-OF-ADDITIONAL_IMPORTS----


/**
 * 複数のレコードをまとめて登録する
 * @param records {string}
 * @param errorObj {IErrorMessage}
 * @return Promise<number|undefined>
 * @throw {Error} Throws Error object
 */
export const bulkCreateRecordProc = async (records: string, errorObj?: IErrorMessage): Promise<number | undefined> => {
  // ----PREPARATION-OF-METHOD----
  // replace here
  // ----END-OF-PREPARATION----

  try {
    const _resp: IResponse = await multiOrganizationCaseDataManagementDrv.multiorgcasemanageCall(true, 'BULKCREATE', undefined, undefined, undefined, undefined, records, undefined, undefined, undefined, undefined, undefined, undefined);
    if (_resp.success) {
      return _resp.result as number;
    } else {
      if (_resp.code === 9999) {
        alert(_resp.message);
        return;
      }
      if (errorObj) {
        errorObj.code = _resp.code;
        errorObj.msg = _resp.message;
      }
      Logger.error(_resp.message);
      return;
    }
  } catch (e) {
    if ((e as Error).toString() === 'Error: refreshToken expired') {
      Logger.info('refreshトークンの期限が切れたためログアウトします');
      await awsLogout('認証トークンの期限が切れたので、お手数ですがもう一度ログインし直してください。');
    }
    if (errorObj) {
      errorObj.code = 10000;
      errorObj.msg = (e as Error).toString();
    }
    return;
  }
};


